<template>
  <section class="login">
    <div class="wrapper d-flex align-items-center">
      <div class="row w-100">
        <div class="col-lg-6 mx-auto">
          <br>
          <br>
          <button v-if="!$auth.isAuthenticated" @click="login">Log in</button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'login',
  methods: {
    // Log the user in
    login () {
      this.$auth.loginWithRedirect()
    }
  },
  mounted () {
    this.login()
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/partials/AppLogin.vue